import React from 'react';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { Layout as RealAssetModalLayout } from 'Views/Page/Content/Modal/Layouts/RealAsset';
import BalanceSheetRealAssetTypeTemplate
  from 'Views/Page/Content/Modal/Layouts/BalanceSheetRealAssetTypeStep/Layout/BalanceSheetRealAssetTypeStepTemplate';

export const BalanceSheetRealAssetTypeLayout = () => {
  const { refreshPageContentCollection } = usePageContentContext();

  return (
    <BalanceSheetRealAssetTypeTemplate onRefresh={refreshPageContentCollection} infoLayoutComponent={RealAssetModalLayout} useFD />
  );
};
